import { redirect } from "@sveltejs/kit";
import { widgetConversationUrl, widgetHomeUrl } from "app/utils/urls";
import type { PageLoad } from "./$types";

// disable across community - only enable ssr on a per-page basis
export const ssr = false;

/** Load community data */
export const load: PageLoad = async ({ parent }) => {
  const { communitySlug, initialUserSessions } = await parent();

  const oneDayAgo = new Date();
  oneDayAgo.setHours(oneDayAgo.getHours() - 24);
  // if there is a user session and it was created in the last 24 hours, redirect to the conversation
  if (initialUserSessions.length > 0 && new Date(initialUserSessions[0].created) > oneDayAgo) {
    redirect(
      302,
      widgetConversationUrl({ communitySlug, conversationId: initialUserSessions[0].slug })
    );
  } else {
    redirect(302, widgetHomeUrl({ communitySlug }));
  }
};
